module.exports = __webpack_public_path__ + "img/derric-pro.547a5a25.jpg";